export type GymFeatureKey =
  | "leaderboard"
  | "boardOfShame"
  | "trainingLogs"
  | "ptProgramming"
  | "profile"
  | "adminInsights"
  | "adminPerformance";

export type GymConfig = {
  brand: {
    name: string;
    shortName: string;
    appName: string;
    description: string;
    memberLabel: string;
    athleteLabel: string;
    installName: string;
    inviteFromName: string;
  };
  assets: {
    logoUrl: string;
    shareMarkUrl: string;
    faviconUrl: string;
  };
  social: {
    instagramHandle: string;
  };
  marketing: {
    demoGymName: string;
    demoDomain: string;
    contactEmail: string;
  };
  training: {
    hubTitle: string;
    benchmarkLabel: string;
    standardTagline: string;
  };
  theme: {
    pageBackground: string;
    pageText: string;
    textMuted: string;
    textSubtle: string;
    border: string;
    surface: string;
    surfaceElevated: string;
    authPanelBackground: string;
    authPanelGlow: string;
    buttonPrimary: string;
    buttonPrimaryText: string;
    buttonSecondaryBackground: string;
    buttonSecondaryBorder: string;
    buttonSecondaryText: string;
    inputBackground: string;
    inputBorder: string;
    inputFocusBorder: string;
    primarySoftBackground: string;
    primarySoftBorder: string;
    primarySoftText: string;
    successSoftBackground: string;
    successSoftBorder: string;
    successSoftText: string;
    dangerSoftBackground: string;
    dangerSoftBorder: string;
    dangerSoftText: string;
    navActiveBackground: string;
    navActiveBorder: string;
    navActiveText: string;
    linkAccent: string;
    accent: string;
    accentStrong: string;
  };
  features: Record<GymFeatureKey, boolean>;
};

export const gymConfig: GymConfig = {
  brand: {
    name: "Locker Room ",
    shortName: "Locker Room",
    appName: "Locker Room Member App",
    description:
      "Locker Room member app for bookings, workouts, progress, and coach-approved access.",
    memberLabel: "member",
    athleteLabel: "Locker Room Athlete",
    installName: "Locker Room",
    inviteFromName: "Locker Room",
  },
  assets: {
    logoUrl: "/LockerRoom.png",
    shareMarkUrl: "/LockerRoom.png",
    faviconUrl: "/favicon.ico",
  },
  social: {
    instagramHandle: "@uselockerroom",
  },
  marketing: {
    demoGymName: "Client Gym Demo",
    demoDomain: "demo.uselockerroom.com",
    contactEmail: "info@uselockerroom.com",
  },
  training: {
    hubTitle: "Locker Room Performance Hub",
    benchmarkLabel: "Locker Room Performance",
    standardTagline: "Locker Room standard",
  },
  theme: {
    pageBackground: "#050505",
    pageText: "#ffffff",
    textMuted: "rgba(255,255,255,0.72)",
    textSubtle: "rgba(255,255,255,0.6)",
    border: "rgba(255,255,255,0.10)",
    surface: "#0f0f10",
    surfaceElevated: "#111214",
    authPanelBackground:
      "linear-gradient(180deg, rgba(18,18,18,0.98), rgba(5,5,5,0.98))",
    authPanelGlow:
      "radial-gradient(circle_at_top_left, rgba(79,110,247,0.18), transparent 28%)",
    buttonPrimary: "linear-gradient(135deg,#4f6ef7,#7b90ff)",
    buttonPrimaryText: "#111111",
    buttonSecondaryBackground: "rgba(255,255,255,0.05)",
    buttonSecondaryBorder: "rgba(255,255,255,0.12)",
    buttonSecondaryText: "#ffffff",
    inputBackground: "rgba(255,255,255,0.04)",
    inputBorder: "rgba(255,255,255,0.10)",
    inputFocusBorder: "rgba(79,110,247,0.45)",
    primarySoftBackground: "rgba(79,110,247,0.12)",
    primarySoftBorder: "rgba(79,110,247,0.24)",
    primarySoftText: "#dbe6ff",
    successSoftBackground: "rgba(16,185,129,0.08)",
    successSoftBorder: "rgba(16,185,129,0.18)",
    successSoftText: "#d1fae5",
    dangerSoftBackground: "rgba(239,68,68,0.10)",
    dangerSoftBorder: "rgba(239,68,68,0.20)",
    dangerSoftText: "#fecaca",
    navActiveBackground: "rgba(255,255,255,0.08)",
    navActiveBorder: "rgba(79,110,247,0.28)",
    navActiveText: "#ffffff",
    linkAccent: "#7b90ff",
    accent: "#4f6ef7",
    accentStrong: "#7b90ff",
  },
  features: {
    leaderboard: true,
    boardOfShame: true,
    trainingLogs: true,
    ptProgramming: true,
    profile: true,
    adminInsights: true,
    adminPerformance: true,
  },
};

export function isFeatureEnabled(feature: GymFeatureKey) {
  return gymConfig.features[feature];
}
